import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CashDrawerTransaction, CashDrawerTransactionCreate, CashDrawerTransactionFilter } from '../data/cashDrawerTransaction';

export function createCashDrawerTransactionService(client: AxiosInstance) {
  return createCrudService<CashDrawerTransaction, CashDrawerTransactionCreate, CashDrawerTransactionFilter>(
    client,
    '/restaurant/CashDrawerTransaction',
    'id',
  );
}

export type CashDrawerTransactionService = CrudService<CashDrawerTransaction, CashDrawerTransactionCreate, CashDrawerTransactionFilter>;
